export const tableSelectProps = {
  sx: {
    "& .MuiSelect-select": {
      textAlign: "start",
      padding: "8px 6px !important",
    },
    "& .MuiSvgIcon-root": {
      right: "0px !important",
    },
  },
};

export const tableAutocompleteProps = {
  "& .MuiInputBase-root": {
    padding: "8px 0 8px 6px",
    "& .MuiInputBase-input": { padding: 0 },
  },
};

export const tableDatePickerProps = {
  "& .MuiInputBase-root .MuiInputBase-input": {
    padding: "8px 0 8px 6px",
  },
  "& .MuiInputAdornment-root .MuiButtonBase-root": {
    padding: "0 4px 0 0px",
  },
};
